import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import debounce from 'lodash.debounce';

import { loadUsers, getUsers, setUserGroups, removeUserFromList, searchUsersInList } from 'modules/users';
import { withZones } from '../Zones';
import render from './render';

export class UsersList extends React.Component {
  static defaultProps = {
    render,
  };

  debouncedSearch = debounce(search => {
    this.props.searchUsersInList({ search });
  }, 200);

  componentDidMount () {
    const { unSelectZone } = this.props;
    this.props.loadUsers();
    unSelectZone();
  }

  search = ({ target: { value: search } }) => this.debouncedSearch(search);

  editUser = id => {
    const { history: { push }, match: { path } } = this.props;
    const url = `${path}/${id}`.replace(/\/\//, '/');
    push(url);
  }

  deleteUser = id => {
    this.props.setUserGroups(id, ['user']);
    this.props.removeUserFromList(id);
  }

  render () {
    const { render: Render, ...nextProps } = this.props;
    const { search, editUser, deleteUser } = this;
    const props = {
      ...nextProps,
      search,
      editUser,
      deleteUser,
    };

    return <Render {...props} />;
  }
}

const mapStateToProps = state => {
  const users = getUsers(state);

  return ({
    users,
    loading: state.users.loading && !users.length,
  });
};

const mapDispatchToProps = dispatch => bindActionCreators({
  loadUsers,
  setUserGroups,
  removeUserFromList,
  searchUsersInList,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withZones(UsersList)));



// WEBPACK FOOTER //
// ./src/components/Admin/UsersManagement/UsersList/index.js